import React, { useEffect } from "react";
import refexLogo from "../../assets/refex_logo.webp";

const RedirectClient = () => {
  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isAndroid = /android/i.test(userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

    if (isAndroid) {
      window.location.href =
        "https://play.google.com/store/apps/details?id=com.refex.eveelz&pcampaignid=web_share";
    } else if (isIOS) {
      window.location.href =
        "https://apps.apple.com/in/app/refex-mobility/id6499511515";
    }
  }, []);

  const userAgent =
    typeof navigator !== "undefined"
      ? navigator.userAgent || navigator.vendor || window.opera
      : "unknown";

  return (
    <div style={styles.container}>
      <div style={styles.logoContainer}>
        <img 
          src={refexLogo} 
          alt="Refex Logo" 
          style={styles.logo}
        />
      </div>
      <h1 style={styles.title}>Refex Mobility</h1>
      <h2 style={styles.subtitle}>Redirecting you to the app...</h2>
      <p style={styles.message}>
        If you are not redirected automatically,{" "}
        <a
          href="https://play.google.com/store/apps/details?id=com.refex.eveelz&pcampaignid=web_share"
          target="_blank"
          rel="noopener noreferrer"
          style={styles.link}
        >
          click here (Android)
        </a>{" "}
        or{" "}
        <a
          href="https://apps.apple.com/in/app/refex-mobility/id6499511515"
          target="_blank"
          rel="noopener noreferrer"
          style={styles.link}
        >
          here (iOS)
        </a>
        .
      </p>
      <p style={styles.ua}>Detected User Agent: {userAgent}</p>
    </div>
  );
};

const styles = {
  container: {
    fontFamily: "Poppins, Arial, sans-serif",
    padding: 40,
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    background: "linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%)",
  },
  logoContainer: {
    marginBottom: 30,
  },
  logo: {
    width: 120,
    height: "auto",
  },
  title: {
    fontSize: 32,
    fontWeight: 700,
    color: "#200772",
    margin: "0 0 10px 0",
  },
  subtitle: {
    fontSize: 18,
    fontWeight: 600,
    color: "#333",
    margin: "10px 0 20px 0",
  },
  message: {
    fontSize: 16,
    color: "#555",
    marginBottom: 20,
    maxWidth: 500,
  },
  link: {
    color: "#70b92f",
    textDecoration: "none",
    fontWeight: 600,
    transition: "color 0.3s ease",
  },
  ua: {
    marginTop: 20,
    fontSize: 12,
    color: "#999",
  },
};

export default RedirectClient;
